import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { OverlayPanel } from "primereact/overlaypanel";

import { format } from "date-fns";
import { mask, unMask } from "remask";
import { formatCurrency } from "../../../../utils/formatCurrency";
import GeraXLSX from "../../../../utils/GeraXLSX";

import classNames from "classnames";
import { BsInfoCircle } from "react-icons/bs";
import { FaCalendarAlt, FaSearch } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import AppCard from "../../../../components/appCard";
import { Api } from "../../../../services/api";
import { DropdownPague, TreeTablePague } from "../../../../styles/primeReactConfig";

function RelatorioComnNegociados() {
  const [infoTable, setInfoTable] = useState(null);
  const [loadTable, setLoadTable] = useState(false);
  const [expandedRows, setExpandedRows] = useState(null);
  const [comnDetails, setComnDetails] = useState(null);

  const op = useRef(null)

  const [searchType, setSearchType] = useState('data_igual');
  const [searchDate, setSearchdate] = useState({
    periodo_inicio: null,
    periodo_fim: null,
    data_unica: new Date(),
  })
  const [searchDocument, setSearchDocument] = useState('')

  const [paginationData, setPaginationData] = useState({
    totalRecords: 0,
    first: 0,
    page: 0,
    rows: 10,
    rowsPerPage: [10, 25, 50]
  })

  useEffect(() => {
    buscaInfoTable()
  }, [paginationData.first, paginationData.rows, paginationData.page])

  //API
  const buscaInfoTable = async () => {
    const limit = paginationData.rows;
    const page = paginationData.page;
    try {
      setLoadTable(true)
      let query = ''
      if (searchType === 'data_igual' && searchDate.data_unica)
        query = `?type=${searchType}&filtro=${format(searchDate.data_unica, 'yyyy-MM-dd')}`
      if (searchType === 'data_menor' && searchDate.periodo_fim)
        query = `?type=${searchType}&filtro=${format(searchDate.periodo_fim, 'yyyy-MM-dd')}`
      if (searchType === 'data_maior' && searchDate.periodo_inicio)
        query = `?type=${searchType}&filtro=${format(searchDate.periodo_inicio, 'yyyy-MM-dd')}`
      if (searchType === 'periodo' && searchDate.periodo_inicio && searchDate.periodo_fim)
        query = `?type=${searchType}&filtro=${format(searchDate.periodo_inicio, 'yyyy-MM-dd')}_${format(searchDate.periodo_fim, 'yyyy-MM-dd')}`
      if (searchType === 'documento' && searchDocument)
        query = `?type=${searchType}&filtro=${unMask(searchDocument)}`


      const { data } = await Api.get(`/relatorio/lembretes_vencimento/${limit}/${page}${query}`);

      setPaginationData(prev => ({ ...prev, totalRecords: data.total }))
      setInfoTable(data.list)
    } catch (error) {
      console.log(error)
      if (!(error.response)) toast.error('Erro 500')
      console.error(error)
      toast.error(error.response.data.error)
      setLoadTable(false)
    } finally {
      setLoadTable(false)
    }
  }

  const downloadInfoTable = async () => {
    const limit = paginationData.totalRecords

    try {
      setLoadTable(true)
      let query = ''
      if (searchType === 'data_igual' && searchDate.data_unica)
        query = `?type=${searchType}&filtro=${format(searchDate.data_unica, 'yyyy-MM-dd')}`
      if (searchType === 'data_menor' && searchDate.periodo_fim)
        query = `?type=${searchType}&filtro=${format(searchDate.periodo_fim, 'yyyy-MM-dd')}`
      if (searchType === 'data_maior' && searchDate.periodo_inicio)
        query = `?type=${searchType}&filtro=${format(searchDate.periodo_inicio, 'yyyy-MM-dd')}`
      if (searchType === 'periodo' && searchDate.periodo_inicio && searchDate.periodo_fim)
        query = `?type=${searchType}&filtro=${format(searchDate.periodo_inicio, 'yyyy-MM-dd')}_${format(searchDate.periodo_fim, 'yyyy-MM-dd')}`
      if (searchType === 'documento' && searchDocument)
        query = `?type=${searchType}&filtro=${unMask(searchDocument)}`


      const { data } = await Api.get(`/relatorio/lembretes_vencimento/${limit}/0${query}`);

      baixarXLSX(data.list)
    } catch (error) {
      console.log(error)
      if (!(error.response)) toast.error('Erro 500')
      console.error(error)
      toast.error(error.response.data.error)
      setLoadTable(false)
    } finally {
      setLoadTable(false)
    }
  }

  //Functions
  function onPage(event) {
    setPaginationData(prev => ({
      ...prev,
      first: parseInt(event.first),
      rows: event.rows,
      page: event.page,
    }))
  }

  function baixarXLSX(list) {
    let arrFormated = []

    for (let item of list) {
      let item_comn_vencido = 0
      let item_comn_vencendo = 0

      for (let boleto of item.boletos) {
        item_comn_vencido += boleto.comn_vencido.length
        item_comn_vencendo += boleto.comn_vencendo.length
      }

      arrFormated.push({
        ...item,
        usuario_documento: formatDocument(item),
        cobranca_valor: formatCurrency(item.cobranca_valor),
        comn_vencido: item_comn_vencido,
        comn_vencendo: item_comn_vencendo
      })
    }

    const nome_arquivo = `Comunicados_pos-Negociacao_${format(new Date(), 'dd-MM-yyyy')}`
    const propsXLSX = [
      { label: "Nome", value: "usuario_nome" },
      { label: "Documento", value: "usuario_documento" },
      { label: "Descrição", value: "cobranca_descricao" },
      { label: "Valor", value: "cobranca_valor" },
      { label: "Boletos Pagos", value: "boletos_pagos" },
      { label: "Boletos Total", value: "boletos_total" },
      { label: "Até o vencimento", value: "comn_vencendo" },
      { label: "Após o vencumento", value: "comn_vencido" },
    ]

    let headers = propsXLSX.map(xlsx => xlsx.label)
    let fields = propsXLSX.map(xlsx => xlsx.value)

    const parametrosXLSX = {
      data: arrFormated,
      headers: headers,
      fields: fields,
      titulo: nome_arquivo
    }
    GeraXLSX(parametrosXLSX)
  }

  //templates

  const templateBoletos = (rowData) => {
    return `${rowData.boletos_pagos}/${rowData.boletos_total}`
  }
  function formatDocument(rowData) {
    const usuario_documento = rowData.usuario_documento
    if (usuario_documento.length <= 11) return mask(usuario_documento, '999.999.999-99')
    if (usuario_documento.length === 14) return mask(usuario_documento, '99.999.999/9999-99')
    return 'Inválido'
  }
  function formatDate(date) {
    if (date) return format(new Date((date + 'T04:01:01.000Z')), 'dd/MM/yyyy')
    return '---'
  };
  function formatDateTime(date) {
    if (date) return format(new Date(date), 'dd/MM/yyyy HH:mm')
    return '---'
  };
  function comnFinalidade(rowData) {
    if (rowData.finalidade === 'vencimento_boleto') return 'Até o vencimento'
    if (rowData.finalidade === 'boleto_vencido') return 'Após o vencimento'
  }
  function boletoStatus(rowData) {
    if (rowData.status === 'not_paid') return 'Não Pago'
    if (rowData.status === 'true') return 'Pago'
  }
  function qtdArr(array) {
    if (!array) return 0
    return array.length
  }
  function totalComn(rowData) {
    const boletos = rowData.boletos
    let comn_vencendo = 0
    let comn_vencido = 0
    for (let i = 0; i < boletos.length; i++) {
      if (!(boletos[i])) continue;
      comn_vencendo += boletos[i].comn_vencendo.length
      comn_vencido += boletos[i].comn_vencido.length
    }

    return (comn_vencendo + comn_vencido)
  }

  const filtroLista = [
    { label: 'Data única', value: 'data_igual' },
    { label: 'Antes de', value: 'data_menor' },
    { label: 'Depois de', value: 'data_maior' },
    { label: 'Período', value: 'periodo' },
    { label: 'Documento', value: 'documento' },
  ]

  const rowExpansionTemplate = (data) => {
    const boletos_comn = data.boletos
    return (
      <div className="w-full bg-gray-100 m-0" style={{ border: '1px solid #F4F4F5' }} >
        <DataTable
          className="w-full"
          dataKey="boleto_id"
          value={boletos_comn}
          filterDisplay="menu"
          emptyMessage='Nenhum registro foi encontrado.'
          scrollHeight="250px"
          size="small"
          scrollable
          showGridlines
          removableSort
        >
          <Column header='Parcela' field="parcela" style={{ justifyContent: 'center', maxWidth: '5rem' }} />
          <Column header='Status' field="status" body={boletoStatus} />
          <Column header='Valor' field="valor" body={(rowData) => formatCurrency(rowData.valor)} />
          <Column header='Aviso até o vencimento' body={(rowData) => qtdArr(rowData.comn_vencendo)} />
          <Column header='Aviso após o vencimento' body={(rowData) => qtdArr(rowData.comn_vencido)} />
          <Column header='Vencimento' field="vencimento" body={(rowData) => formatDate(rowData.vencimento)} />
          <Column header='Pagamento em' field="pagamento" body={(rowData) => formatDate(rowData.pagamento)} />
          <Column header='Gerado em' field="created_at" body={(rowData) => formatDate(rowData.created_at)} />
          <Column header='Info' body={buttonDetails} style={{ justifyContent: 'center', maxWidth: '5rem' }} />
        </DataTable>
      </div>
    );
  }

  const buttonDetails = (rowData) => {
    const details = rowData.comn_vencendo.concat(rowData.comn_vencido).sort((a, b) => new Date(a.regdate) - new Date(b.regdate))
    const disabled = !(details.length > 0)

    return <Button
      icon={<BsInfoCircle className="text-3xl text-black" />}
      pt={{
        root: ({ props, context }) => ({
          className: classNames(`hover:dark:bg-amber-200 hover:bg-yellow-500 
        dark:bg-amber-400 bg-yellow-300
        h-12 w-12 rounded-full 
        flex justify-center items-center
        text-white dark:text-black 
        transition duration-300`,
            { 'opacity-60 pointer-events-none cursor-default': context.disabled }
          )
        }),
        label: "absolute"
      }}
      onClick={(e) => { op.current.toggle(e); setComnDetails(details) }}
      disabled={disabled}
    />
  }

  const headerComnNegociados = (
    <div className="grid gap-4">
      <h5 className="text-2xl">Comunicados Pós-Negociação</h5>
      <div className="grid md:flex w-full gap-2">
        <Dropdown
          options={filtroLista}
          value={searchType}
          pt={DropdownPague}
          onChange={(e) => {
            setSearchType(e.value);
            setSearchdate({
              periodo_inicio: new Date(),
              periodo_fim: new Date(),
              data_unica: new Date()
            });
            setSearchDocument('')
          }
          }
        />
        {searchType === 'data_igual' &&
          <Calendar
            value={searchDate.data_unica}
            onChange={(e) => setSearchdate(prev => ({
              ...prev,
              data_unica: e.value
            }))}
            showIcon
            mask="99/99/9999"
            showOnFocus={false}
            icon={<FaCalendarAlt className={
              classNames('px-4 rounded-r-lg',
                'w-[50px] h-full',
                'bg-sky-400 text-white hover:bg-sky-500',
                'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
              )}
            />}
            placeholder="dd/mm/yyyyy"
            dateFormat="dd/mm/yy"
          />
        }
        {searchType === 'data_menor' &&
          <Calendar
            value={searchDate.periodo_fim}
            onChange={(e) => setSearchdate(prev => ({
              ...prev,
              periodo_fim: e.value
            }))}
            showIcon
            mask="99/99/9999"
            showOnFocus={false}
            icon={<FaCalendarAlt className={
              classNames('px-4 rounded-r-lg',
                'w-[50px] h-full',
                'bg-sky-400 text-white hover:bg-sky-500',
                'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
              )}
            />}
            placeholder="dd/mm/yyyyy"
            dateFormat="dd/mm/yy"
          />
        }
        {searchType === 'data_maior' &&
          <Calendar
            value={searchDate.periodo_inicio}
            onChange={(e) => setSearchdate(prev => ({
              ...prev,
              periodo_inicio: e.value
            }))}
            showIcon
            mask="99/99/9999"
            showOnFocus={false}
            icon={<FaCalendarAlt className={
              classNames('px-4 rounded-r-lg',
                'w-[50px] h-full',
                'bg-sky-400 text-white hover:bg-sky-500',
                'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
              )}
            />}
            placeholder="dd/mm/yyyyy"
            dateFormat="dd/mm/yy"
          />
        }
        {searchType === 'periodo' &&
          <Calendar
            value={searchDate.periodo_inicio}
            maxDate={searchDate.periodo_fim}
            onChange={(e) => setSearchdate(prev => ({
              ...prev,
              periodo_inicio: e.value
            }))}
            showIcon
            mask="99/99/9999"
            showOnFocus={false}
            icon={<FaCalendarAlt className={
              classNames('px-4 rounded-r-lg',
                'w-[50px] h-full',
                'bg-sky-400 text-white hover:bg-sky-500',
                'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
              )}
            />}
            placeholder="Dia Inicial"
            dateFormat="dd/mm/yy"
          />
        }
        {searchType === 'periodo' &&
          <Calendar
            value={searchDate.periodo_fim}
            minDate={searchDate.periodo_inicio}
            onChange={(e) => setSearchdate(prev => ({
              ...prev,
              periodo_fim: e.value
            }))}
            showIcon
            mask="99/99/9999"
            showOnFocus={false}
            icon={<FaCalendarAlt className={
              classNames('px-4 rounded-r-lg',
                'w-[50px] h-full',
                'bg-sky-400 text-white hover:bg-sky-500',
                'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
              )}
            />}
            placeholder="Dia Final"
            dateFormat="dd/mm/yy"
          />
        }
        {searchType === 'documento' &&
          <InputText
            className="md:w-11rem w-full md:mx-1 md:my-0 my-1"
            value={searchDocument}
            onChange={(e) => { setSearchDocument(mask(e.target.value, ['999.999.999-99', '99.999.999/9999-99'])) }}
            placeholder="Insira CPF ou CNPJ"
          />
        }
        <div className="flex gap-3">
          <Button
            icon={<FaSearch />}
            severity="success"
            onClick={() => buscaInfoTable()}
            style={{ minWidth: '2.75rem', minHeight: '2.5rem' }}
          />
          <Button
            icon={<FiDownload />}
            onClick={() => downloadInfoTable()}
            style={{ minWidth: '2.75rem', minHeight: '2.5rem' }}
          />
        </div>
      </div>
    </div>
  )

  return (
    <div>
      
      <AppCard className="grid overflow-x-auto ">
        <OverlayPanel ref={op}>
          <DataTable
            className="w-full"
            value={comnDetails}
            scrollHeight="250px"
            size="small"
            scrollable
            showGridlines
          >
            <Column header='Finalidade' field="finalidade" body={comnFinalidade} />
            <Column header='Canal' field="canal" />
            <Column header='Envio em' field="regdate" body={(rowData) => formatDateTime(rowData.regdate)} />
          </DataTable>
        </OverlayPanel>

        <DataTable
          className="w-full"
          dataKey="cobranca_id"
          header={headerComnNegociados}
          value={infoTable}
          loading={loadTable}
          totalRecords={paginationData.totalRecords}
          first={paginationData.first}
          rows={paginationData.rows}
          rowsPerPageOptions={paginationData.rowsPerPage}
          onPage={onPage}
          pt={TreeTablePague}
          rowExpansionTemplate={rowExpansionTemplate}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
          paginatorTemplate=" FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
          emptyMessage='Nenhum registro foi encontrado.'
          paginator
          lazy
        >
          <Column expander style={{ minwidth: '2rem' }} bodyClassName="text-center" />
          <Column header="Nome" field="usuario_nome" style={{ minWidth: '8rem' }} />
          <Column header="Documento" field="usuario_documento" body={formatDocument} style={{ minWidth: '4rem' }} />
          <Column header="Descrição" field="cobranca_descricao" style={{ minWidth: '5rem' }} />
          <Column header="Valor" field="cobranca_valor" body={(rowData) => formatCurrency(rowData.cobranca_valor)} style={{ minWidth: '5rem' }} />
          <Column header="Parcelas" body={templateBoletos} style={{ minWidth: '3rem' }} />
          <Column header="Qtd. Comunicações" body={(rowData) => totalComn(rowData)} style={{ minwidth: '5rem' }} />
        </DataTable>
      </AppCard>
    </div>)
}

export default RelatorioComnNegociados